import { useAtom } from '@reatom/npm-react'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { CurrencyModel } from '@root/entities/currency/model'
import { FlashTextContentDistinct } from '@root/features/flash/flash-text-content-distinct'
import { AmountFormatted } from '@root/shared/core/format'

import type { PairModel } from '../atoms'

export const PairFeeTooltipContent = memo(({ pair }: { pair: PairModel }) => {
  const { t } = useTranslation()
  const nativeCurrency = CurrencyModel.nativeOf(pair.network)
  const [totalPriorityFees] = useAtom(pair.fees.totalPriorityFees)
  const [totalBundleTipsFees] = useAtom(pair.fees.totalBundleTipsFees)

  return (
    <Root>
      <p>
        {t('pair.fees.priority-fees')}
        <FlashTextContentDistinct>
          <AmountFormatted
            amount={totalPriorityFees}
            currency={nativeCurrency.ticker}
          />
        </FlashTextContentDistinct>
      </p>
      <p>
        {t('pair.fees.bundle-fees')}
        <FlashTextContentDistinct>
          <AmountFormatted
            amount={totalBundleTipsFees}
            currency={nativeCurrency.ticker}
          />
        </FlashTextContentDistinct>
      </p>
    </Root>
  )
})

const Root = styled.div`
  display: grid;
  min-width: 150px;
  gap: 2px;

  p {
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 8px;

    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
  }
`
